import { moneyFormatter } from '../../utils';

interface MoneyProps {
  colorScheme?: 'light' | 'dark';
  children: number;
}

export function Money({ children, colorScheme }: MoneyProps) {
  const isDark = colorScheme === 'dark';

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
        isDark
          ? 'bg-money-dark text-text-inverse dark:text-text-primary'
          : 'bg-money-light text-text-primary dark:text-text-inverse'
      }`}
    >
      {moneyFormatter.format(children)}
    </span>
  );
}
